import { object } from "yup";

export const EmployeeSalaryValidationSchema = object({

});
